import React from 'react';
import DataGrid, { Button, Column, ValidationRule, RequiredRule, GroupPanel} from "devextreme-react/data-grid";
import LicenceDataSource from '../datasource/LicenceDataSource';
import { useAuthStore } from '../hooks/useAuthStore';
import CommonLicenceDataGrid from './CommonLicenceDataGrid';
import { BrowserRouter, Link, useNavigate } from 'react-router-dom';
import { Button as RealButton} from "devextreme-react";
import { isMobileDevice } from "../utils/DeviceDetect";

const ReportsList = () => {
    const authStore = useAuthStore();
    const navigate = useNavigate();
    const licenceStore = LicenceDataSource.licenceStore(
        {
            url: LicenceDataSource.reportUrl,
            authStore: authStore,
            cacheDuration: 0,
        }
    );


    const onRunButtonClick = async (e) => {
        if (e && e.row && e.row.data) {
//            let url = `${LicenceDataSource.baseUrl}/?reportId=${e.row.data.Id}`;
            let url = `/?reportId=${e.row.data.Id}`;
            window.open(url);
            return;
            if (authStore.storage["useTabPanel"]) {
                authStore.storage["addTabForReportView"](e.row.data.Name, e.row.data.Id);
            }
            else {
                navigate(`/reports/${e.row.data.Id}`, { replace: true });
            }
        }
    }

    const nameCellRender = (cellData) => {
        let link = `/reports/${cellData.data.Id}`;
//        console.log(cellData);
        if (authStore.storage["useTabPanel"]) {
            return (
                <a
                    href={link}
                    onClick={(e) => {
                        if (isMobileDevice) {
                            let url = `/?reportId=${cellData.data.Id}`;
                            window.open(url);
                        }
                        else {
                            authStore.storage["addTabForReportView"](cellData.data.Name, cellData.data.Id);
                        }
                        e.preventDefault();
                        return false;
                    }}
                >
                    {cellData.data.Name}
                </a>
            );
            return (
                <RealButton
                    width="100%"
                    height="100%"
                    onClick={(e) => {
                        authStore.storage["addTabForReportView"](cellData.data.Name, cellData.data.Id);
                        return false;
                    }}
                >
                    {cellData.data.Name}
                </RealButton>
            );
        }
        else {
            return (
                <a
                    href={link}
                >
                    {cellData.data.Name}
                </a>
            );
        }
    }


    return (
        <CommonLicenceDataGrid
            allowColumnReordering={isMobileDevice ? false : true}
            licenceStore={licenceStore}
            columnAutoWidth={false}
            summary={{
                totalItems: [
                    { column: "Name", summaryType: "count", displayFormat: "Записей: {0}", valueFormat: "#" }
                ],
                groupItems: [
                    { column: "Name", summaryType: "count", displayFormat: "Записей: {0}", valueFormat: "#" }
                ]
            }}

        >
            <GroupPanel
                visible={true}
                allowColumnDragging={isMobileDevice ? false : true}
            />

            <Column
                dataField="GroupName"
                caption="Группа"
                width="30%"
                groupIndex={0}
//                defaultSortOrder="asc"
//                defaultSortIndex={0}
            >
            </Column>
            <Column
                dataField="Code"
                caption="Код"
                visible={false}
            >
                <RequiredRule />
            </Column>
            <Column
                dataField="Name"
                caption="Наименование"
                width="100%"
                cellRender={nameCellRender}
                defaultSortOrder="asc"
                defaultSortIndex={0}
            >
                <ValidationRule type="required" />
            </Column>
            <Column
                dataField="Id"
                caption="ID"
                hidingPriority={0}
                visible={false}
            />
            <Column type='buttons' visible={!isMobileDevice}>
                <Button
                    icon="video"
                    text="Построить отчет в новой вкладке"
                    hint="Построить отчет в новой вкладке"
                    onClick={onRunButtonClick}
                />
            </Column>
        </CommonLicenceDataGrid>
    );
}


export default React.memo(ReportsList);
